import { cn } from "@/utils/classnames"
import { forwardRef, InputHTMLAttributes } from "react"

interface OTPInputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const OTPInput = forwardRef<HTMLInputElement, OTPInputProps>(({ ...props }, ref) => {
  return (
    <input
      ref={ref}
      type="tel"
      {...props}
      className={cn(
        "border-0 bg-transparent text-body1-md placeholder:text-fg-3 focus:outline-none focus:ring-0 focus:placeholder:text-transparent lg:text-body1-lg",
        props.className
      )}
    />
  )
})

OTPInput.displayName = "OTPInput"
